"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'explainCard',
  props: {
    explainTitle: {
      // 配置说明标题
      type: String,
      default: ''
    },
    explainText: {
      // 配置说明内容
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  }
};